import { AutoComplete, AutoCompleteField } from '@components/form';
import { participantsClassificationTypeEnum } from '@modules/events/_eventsEnums';
import { get, differenceBy } from 'lodash';
import * as React from 'react';
import { Col, Grid, Row } from 'react-flexbox-grid';
import { compose, withProps } from 'recompose';
import { reduxForm, formValueSelector } from 'redux-form';
import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { connect } from 'react-redux';

const enhance = compose<any, any>(
  connect<any>(state => ({
    classificationType: formValueSelector('module-events-participants')(state, 'classificationType')
  })),
  withProps(({ initialValues, classificationType }) => ({
    classificationTypeEnum: differenceBy(
      participantsClassificationTypeEnum,
      classificationType.filter(c => get(c, 'id') !== get(initialValues, 'id')),
      c => get(c, 'id')
    )
  })),
  reduxForm({
    form: 'module-events-participants-classificationType'
  })
);

const View: React.SFC<any> = ({ handleSubmit, closeItem, classificationTypeEnum }) => (
  <div>
    <form className="layout" onSubmit={handleSubmit}>
      <Grid fluid={true}>
        <Row>
          <Col className="grid-system-margin" />
        </Row>
        <Row>
          <Col md={4}>
            <h4>Klasifikace</h4>
          </Col>
          <Col md={8}>
            <AutoCompleteField
              component={AutoComplete}
              name="id"
              items={classificationTypeEnum}
              fullWidth={true}
              labelFunction={o => get(o, 'label')}
              valueFunction={o => get(o, 'id')}
              arrowstyle={{
                color: '#e1e0e1',
                position: 'absolute',
                right: 0,
                top: 16
              }}
            />
          </Col>
        </Row>
      </Grid>
      <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '16px 0 16px 16px' }} />
      <Button label="Zrušit" style={{ margin: '16px 0 16px 16px' }} onClick={closeItem} />
    </form>
  </div>
);

export const EventsFormParticipantsParticipantsClassificationTypeForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/events/EventsFormParticipantsParticipantsClassificationTypeForm.tsx